import {useState, useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {useAppContext} from "../../contexts/AppContext";
import {requester} from "../../services/requester";
import {settlementLabel} from "../../utils/settlements";

// Е2: всяка справка в собствена карта/секция, подредени С1 → С9. БЕЗ
// преномериране (то чака отговор — Е7); тук само подредба и единен формат на
// заглавията (Е3). Е8: С5/С6 имат опционален филтър „Ползвател".

// Модулно-ниво помощни компоненти — стабилна идентичност (не се ремонтират на
// всеки клавиш, за да не губят фокус input-ите type=search).
const CompanyPicker = ({label, value, onChange, listId, options, placeholder = "Изберете ползвател..."}) => (
    <div>
        {label && <label className="form-label">{label}</label>}
        <input type="search" className="form-control" style={{maxWidth: "400px"}}
               list={listId} placeholder={placeholder}
               value={value} onChange={e => onChange(e.target.value)}/>
        <datalist id={listId}>
            {options.map(c => <option key={c.bullstat} value={c.label}/>)}
        </datalist>
    </div>
);

const SettlementPicker = ({label, value, onChange, listId, options, disabled = false}) => (
    <div>
        {label && <label className="form-label">{label}</label>}
        <input type="search" className="form-control" style={{maxWidth: "400px"}}
               list={listId} placeholder="Изберете землище..." disabled={disabled}
               value={value} onChange={e => onChange(e.target.value)}/>
        <datalist id={listId}>
            {options.map(s => <option key={s.ekatte} value={`${s.name}, ${s.ekatte}`}/>)}
        </datalist>
    </div>
);

const MunicipalityPicker = ({label, value, onChange, listId, options, disabled = false}) => (
    <div>
        {label && <label className="form-label">{label}</label>}
        <input type="search" className="form-control" style={{maxWidth: "400px"}}
               list={listId} placeholder="Изберете община..." disabled={disabled}
               value={value} onChange={e => onChange(e.target.value)}/>
        <datalist id={listId}>
            {options.map(m => <option key={m} value={m}/>)}
        </datalist>
    </div>
);

// Щ3 — описанията под имената на справките. Пише се КАК се смята справката, не
// какво „показва": разликата между две справки често е точно в сметката.
// Същото го има и в „Помощ", но там се стига нарочно; тук се чете в движение.
const HINTS = {
    s1: "Всички ползватели с декларации в землището за годината. На всеки ред: декларирана, "
        + "необработваема и годна площ, бели петна, пътища, други площи, сборът на замените, "
        + "правно основание и изчертано. Редовете са низходящо по изчертана площ.",
    s2: "Един ред на землище за избрания ползвател — същите колони като С1, плюс общо за "
        + "всички землища. Редовете са низходящо по изчертана площ.",
    s3: "За едно землище: изходните площи на ползвателя, всяка негова замяна поотделно "
        + "(с насрещния ползвател и землище) и всички изчертани масиви с култура и забележка. "
        + "Накрая — подписен блок.",
    s4: "Същото като С3, но БЕЗ списъка със замени — само изходните площи, сборът на "
        + "замените и изчертаните масиви.",
    // Ъ16: общото за С3 и С4 — изборът „или Община".
    s3s4Municipality: "Попълнете землище ИЛИ община. При община излиза справката за всяко "
        + "землище в нея, в което ползвателят има декларация (дори да не е чертал там) — "
        + "една под друга, а PDF-ът е общ: всяко землище на своя страница, със свой подпис.",
    // С8 няма подписен блок — затова описанието е без „със свой подпис".
    s8Municipality: "Попълнете землище ИЛИ община. При община излиза справката за всяко "
        + "землище в нея, в което ползвателят има декларация — една под друга, а PDF-ът е "
        + "общ: всяко землище на своя страница.",
    s5: "Замените в избрания обхват, групирани по двойка страни и посока: еднаквата посока "
        + "се сумира в един ред, обратната посока е ОТДЕЛЕН ред. Нищо не се нетира — вижда "
        + "се какво е дадено и какво е получено поотделно.",
    s6: "За всяка двойка страни двете посоки се НЕТИРАТ и остава по един протокол с "
        + "разликата. Взаимно погасените двойки (равни в двете посоки) отпадат и се броят "
        + "отделно. Всеки протокол е на отделна страница в общия PDF.",
    s7: "По села колко дава всеки от двамата. В ОБЩО влизат само землищата по име — "
        + "неопределеното е огледалният запис на същите замени и стои на свой ред. "
        + "Равни рамене се проверяват на реда „Всичко“, не по разликата по села.",
    s8: "Същото като С3, плюс колона „Корекция“ — ръчната поправка към годната площ, "
        + "която иначе се вижда само в „Други площи“.",
    s9: "Всички ползватели в землището с правно основание, годна площ, изчертано и налично. "
        + "Равнението е Σ правно = Σ изчертано + Σ налично. Червеният ред събира "
        + "над-изчерталите, зеленият — тези, на които още остава площ за чертане.",
    s10: "Всички замени на един ползвател във ВСИЧКИ землища, разделени на „дава“ и "
         + "„получава“, с насрещния ползвател и землище на всеки ред.",
    s11: "Землище / масив / МПО / площ / култура / забележка за всички землища, а накрая "
         + "общо по култури с проценти и торта-диаграма.",
    s12: "Чакащи одобрение, одобрени, отказани и замени към неопределени землища. Полезна е "
         + "най-вече за землища, които не са зададени на никого — там няма кой друг да "
         + "погледне.",
    s13: "Въведените бели петна и пътища по ползвател, със сборове по землище. Ползвател без "
         + "въведени данни излиза с нули — нарочно, за да се види кой не е попълнен. В самата "
         + "справка има превключване към цялата община.",
    s14: "Изчертаното по МАСИВИ за миналата и за тази стопанска година и разликата между тях. "
         + "МПО номерата в един масив се сумират (те се преномерират между годините). Масив, "
         + "който го има само в едната година, влиза с нула в другата.",
};

const ReportCard = ({title, hint, children}) => (
    <div className="card mt-3">
        <div className="card-body">
            <h6 className="card-title" style={{color: "var(--app-gold)"}}>{title}</h6>
            {hint && <div className="text-muted mb-2" style={{fontSize: "0.9rem"}}>{hint}</div>}
            {children}
        </div>
    </div>
);

export const ReportSelector = () => {
    const {year} = useParams();
    const navigate = useNavigate();
    const {settlements, companies} = useAppContext();
    const request = requester();

    const [settlementsWithData, setSettlementsWithData] = useState([]);
    const [municipalitiesWithData, setMunicipalitiesWithData] = useState([]);

    // Отделно състояние за всяка карта — картите са независими.
    const [s1Settlement, setS1Settlement] = useState('');
    const [s2Company, setS2Company] = useState('');
    const [s3Company, setS3Company] = useState('');
    const [cropsCompany, setCropsCompany] = useState('');
    const [s3fCompany, setS3fCompany] = useState('');
    const [s3fSettlement, setS3fSettlement] = useState('');
    const [s4Company, setS4Company] = useState('');
    const [s4Settlement, setS4Settlement] = useState('');
    // Ъ16: С3/С4 — вместо землище може да се избере цяла община.
    const [s3fMunicipality, setS3fMunicipality] = useState('');
    const [s4Municipality, setS4Municipality] = useState('');
    const [crossSettlement, setCrossSettlement] = useState('');
    const [crossMunicipality, setCrossMunicipality] = useState('');
    const [crossCompany, setCrossCompany] = useState('');
    const [protSettlement, setProtSettlement] = useState('');
    const [protMunicipality, setProtMunicipality] = useState('');
    const [protCompany, setProtCompany] = useState('');
    const [betweenCompany1, setBetweenCompany1] = useState('');
    const [betweenCompany2, setBetweenCompany2] = useState('');
    const [s8Company, setS8Company] = useState('');
    const [s8Settlement, setS8Settlement] = useState('');
    const [s8Municipality, setS8Municipality] = useState('');
    const [s9Settlement, setS9Settlement] = useState('');
    const [s13Settlement, setS13Settlement] = useState('');
    const [s14Settlement, setS14Settlement] = useState('');
    const [s14Municipality, setS14Municipality] = useState('');
    const [s14Company, setS14Company] = useState('');

    // Ъ16: ЕКАТТЕ-тата с данни за годината се пазят отделно, а имената и
    // общините се смятат, щом са налице И те, И списъкът със землища. Досега
    // всичко се смяташе само при смяна на годината: отвореше ли се страницата
    // направо (презареждане, запазен адрес), а годината дойдеше преди
    // землищата, изборът „община" оставаше празен (С5, С6, С14, С3/С4), а
    // вместо имена на землища излизаха ЕКАТТЕ.
    const [ekattesWithData, setEkattesWithData] = useState([]);
    useEffect(() => {
        request.get(`${baseUrl()}/companies-initial-info/${year}/ids`)
            .then(data => {
                if (Array.isArray(data)) {
                    setEkattesWithData([...new Set(data.map(d => d.settlement_ekatte))]);
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year]);

    useEffect(() => {
        const matched = ekattesWithData.map(e => {
            const s = settlements.find(s => s.ekatte === e);
            // Ж1: „община" пред името. ЕКАТТЕ остава последната част
            // на стойността в datalist-а (extractLast разчита на това).
            return s
                ? {ekatte: e, name: settlementLabel(s, {withRegion: false})}
                : {ekatte: e, name: e};
        }).sort((a, b) => a.name.localeCompare(b.name));
        setSettlementsWithData(matched);

        const municipalities = [...new Set(ekattesWithData
            .map(e => settlements.find(s => s.ekatte === e)?.municipality)
            .filter(Boolean))].sort((a, b) => a.localeCompare(b));
        setMunicipalitiesWithData(municipalities);
    }, [ekattesWithData, settlements]);

    const companiesOptions = companies.map(c => ({
        bullstat: c.bullstat,
        label: `${c.company_name}, ${c.bullstat}`
    }));

    const extractLast = (val) => {
        const parts = (val || '').split(',');
        return parts[parts.length - 1]?.trim();
    };

    const scopeTarget = (settlementVal, municipalityVal) => {
        if (settlementVal) {
            const ekatte = extractLast(settlementVal);
            return ekatte ? `settlement/${encodeURIComponent(ekatte)}` : null;
        }
        if (municipalityVal) return `municipality/${encodeURIComponent(municipalityVal)}`;
        return null;
    };

    const goS1 = () => {
        const ekatte = extractLast(s1Settlement);
        if (ekatte) navigate(`/${year}/reports/s1/${ekatte}`);
    };
    const goS2 = () => {
        const bs = extractLast(s2Company);
        if (bs) navigate(`/${year}/reports/s2/${bs}`);
    };
    const goS3 = () => {
        const bs = extractLast(s3Company);
        if (bs) navigate(`/${year}/reports/s3/${bs}`);
    };
    const goCrops = () => {
        const bs = extractLast(cropsCompany);
        if (bs) navigate(`/${year}/reports/crops/${bs}`);
    };
    const goUserReport = (route, companyVal, settlementVal) => {
        const bs = extractLast(companyVal);
        const ekatte = extractLast(settlementVal);
        if (bs && ekatte) navigate(`/${year}/reports/${route}/${ekatte}/${bs}`);
    };
    // Ъ16: С3/С4 — землище ИЛИ община (точно едно от двете, както при С5/С6/С14).
    const goUserReportScope = (route, companyVal, settlementVal, municipalityVal) => {
        const bs = extractLast(companyVal);
        if (!bs) return;
        if (settlementVal) {
            const ekatte = extractLast(settlementVal);
            if (ekatte) navigate(`/${year}/reports/${route}/${ekatte}/${bs}`);
        } else if (municipalityVal) {
            navigate(`/${year}/reports/${route}/municipality/${encodeURIComponent(municipalityVal)}/${bs}`);
        }
    };
    const goBetween = () => {
        const bs1 = extractLast(betweenCompany1);
        const bs2 = extractLast(betweenCompany2);
        if (bs1 && bs2) navigate(`/${year}/reports/s4/${bs1}/${bs2}`);
    };
    // Е8: опционален булстат по query string (не чупи сегашните роутове).
    const goScopeReport = (route, settlementVal, municipalityVal, companyVal) => {
        const t = scopeTarget(settlementVal, municipalityVal);
        if (!t) return;
        const bs = companyVal ? extractLast(companyVal) : null;
        const q = bs ? `?bullstat=${bs}` : '';
        navigate(`/${year}/reports/${route}/${t}${q}`);
    };
    // Ф4: С13 се отваря по землище; вътре има превключване към цялата община,
    // затова тук не се дублира избор на община.
    const goS13 = () => {
        const ekatte = extractLast(s13Settlement);
        if (ekatte) navigate(`/${year}/reports/s13/${ekatte}`);
    };
    const goControl = () => {
        const ekatte = extractLast(s9Settlement);
        if (ekatte) navigate(`/${year}/reports/control/${ekatte}`);
    };

    return (
        <div className="mt-3">
            <h4 style={{color: "var(--app-gold)"}}>Справки — Стопанска {year} година</h4>

            {/* С1 */}
            <ReportCard title="С1 — Справка на землище" hint={HINTS.s1}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker value={s1Settlement} onChange={setS1Settlement}
                                      listId="s1-settlements" options={settlementsWithData}/>
                    <button className="btn btn-outline-primary" onClick={goS1}
                            disabled={!s1Settlement}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С2 */}
            <ReportCard title="С2 — Справка по ползвател за всички землища" hint={HINTS.s2}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker value={s2Company} onChange={setS2Company}
                                   listId="s2-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary" onClick={goS2}
                            disabled={!s2Company}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С3 — Пълна справка по ползвател за село */}
            <ReportCard title="С3 — Пълна справка по ползвател" hint={`${HINTS.s3} ${HINTS.s3s4Municipality}`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker label="Ползвател:" value={s3fCompany} onChange={setS3fCompany}
                                   listId="s3f-company" options={companiesOptions}/>
                    <SettlementPicker label="Землище:" value={s3fSettlement} onChange={setS3fSettlement}
                                      listId="s3f-settlement" options={settlementsWithData}
                                      disabled={!!s3fMunicipality}/>
                    <MunicipalityPicker label="или Община:" value={s3fMunicipality} onChange={setS3fMunicipality}
                                        listId="s3f-municipality" options={municipalitiesWithData}
                                        disabled={!!s3fSettlement}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goUserReportScope('s5', s3fCompany, s3fSettlement, s3fMunicipality)}
                            disabled={!s3fCompany || (!s3fSettlement && !s3fMunicipality)}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С4 — Обща справка по ползвател за село */}
            <ReportCard title="С4 — Обща справка по ползвател" hint={`${HINTS.s4} ${HINTS.s3s4Municipality}`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker label="Ползвател:" value={s4Company} onChange={setS4Company}
                                   listId="s4-company" options={companiesOptions}/>
                    <SettlementPicker label="Землище:" value={s4Settlement} onChange={setS4Settlement}
                                      listId="s4-settlement" options={settlementsWithData}
                                      disabled={!!s4Municipality}/>
                    <MunicipalityPicker label="или Община:" value={s4Municipality} onChange={setS4Municipality}
                                        listId="s4-municipality" options={municipalitiesWithData}
                                        disabled={!!s4Settlement}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goUserReportScope('s4general', s4Company, s4Settlement, s4Municipality)}
                            disabled={!s4Company || (!s4Settlement && !s4Municipality)}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С5 — ДЗ кръстосана (землище или община), опционален ползвател (Е8) */}
            <ReportCard title="С5 — ДЗ кръстосана"
                        hint={`${HINTS.s5} Попълнете само едно от двете; при община — село по село.`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker label="Землище:" value={crossSettlement} onChange={setCrossSettlement}
                                      listId="cross-settlement" options={settlementsWithData}
                                      disabled={!!crossMunicipality}/>
                    <MunicipalityPicker label="или Община:" value={crossMunicipality} onChange={setCrossMunicipality}
                                        listId="cross-municipality" options={municipalitiesWithData}
                                        disabled={!!crossSettlement}/>
                    <CompanyPicker label="Ползвател:" value={crossCompany} onChange={setCrossCompany}
                                   listId="cross-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goScopeReport('cross', crossSettlement, crossMunicipality, crossCompany)}
                            disabled={(!crossSettlement && !crossMunicipality) || !crossCompany}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С6 — ДЗ-протоколи (землище или община), опционален ползвател (Е8) */}
            <ReportCard title="С6 — ДЗ-протоколи"
                        hint={`${HINTS.s6} Попълнете само едно от двете.`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker label="Землище:" value={protSettlement} onChange={setProtSettlement}
                                      listId="prot-settlement" options={settlementsWithData}
                                      disabled={!!protMunicipality}/>
                    <MunicipalityPicker label="или Община:" value={protMunicipality} onChange={setProtMunicipality}
                                        listId="prot-municipality" options={municipalitiesWithData}
                                        disabled={!!protSettlement}/>
                    <CompanyPicker label="Ползвател:" value={protCompany} onChange={setProtCompany}
                                   listId="prot-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goScopeReport('protocols', protSettlement, protMunicipality, protCompany)}
                            disabled={(!protSettlement && !protMunicipality) || !protCompany}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С7 — ДЗ между двама ползватели */}
            <ReportCard title="С7 — ДЗ между двама ползватели" hint={HINTS.s7}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker label="Ползвател 1:" value={betweenCompany1} onChange={setBetweenCompany1}
                                   listId="between-company-1" options={companiesOptions}/>
                    <CompanyPicker label="Ползвател 2:" value={betweenCompany2} onChange={setBetweenCompany2}
                                   listId="between-company-2" options={companiesOptions}/>
                    <button className="btn btn-outline-primary" onClick={goBetween}
                            disabled={!betweenCompany1 || !betweenCompany2}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С8 — Справка по ползвател с корекция */}
            <ReportCard title="С8 — Справка по ползвател с корекция" hint={`${HINTS.s8} ${HINTS.s8Municipality}`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker label="Ползвател:" value={s8Company} onChange={setS8Company}
                                   listId="s8-company" options={companiesOptions}/>
                    <SettlementPicker label="Землище:" value={s8Settlement} onChange={setS8Settlement}
                                      listId="s8-settlement" options={settlementsWithData}
                                      disabled={!!s8Municipality}/>
                    <MunicipalityPicker label="или Община:" value={s8Municipality} onChange={setS8Municipality}
                                        listId="s8-municipality" options={municipalitiesWithData}
                                        disabled={!!s8Settlement}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goUserReportScope('s8', s8Company, s8Settlement, s8Municipality)}
                            disabled={!s8Company || (!s8Settlement && !s8Municipality)}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С9 — Контролна справка на землище */}
            <ReportCard title="С9 — Контролна справка на землище" hint={HINTS.s9}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker value={s9Settlement} onChange={setS9Settlement}
                                      listId="s9-settlements" options={settlementsWithData}/>
                    <button className="btn btn-outline-primary" onClick={goControl}
                            disabled={!s9Settlement}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* З1а: възложителят даде финалната номерация — тази справка е С10.
                „по ползвател" остава в името, иначе съвпада със „С5 — ДЗ
                кръстосана". URL-ът `/reports/s3` не се пипа. */}
            <ReportCard title="С10 — ДЗ кръстосана по ползвател" hint={HINTS.s10}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker value={s3Company} onChange={setS3Company}
                                   listId="s3-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary" onClick={goS3}
                            disabled={!s3Company}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* З1: новата справка е последна в номерацията. */}
            <ReportCard title="С11 — Обобщени култури по ползвател" hint={HINTS.s11}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <CompanyPicker value={cropsCompany} onChange={setCropsCompany}
                                   listId="crops-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary" onClick={goCrops}
                            disabled={!cropsCompany}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* К: състояние на одобренията — няма избор на ползвател/землище,
                справката е за всичко, до което човекът има достъп. */}
            <ReportCard title="С12 — Замени по състояние на одобрението" hint={HINTS.s12}>
                <button className="btn btn-outline-primary"
                        onClick={() => navigate(`/${year}/reports/s12`)}>Покажи
                </button>
            </ReportCard>

            {/* С13 — БП и пътища (Ф4). Ц4: картата ѝ стои СЛЕД С12 — редът на
                картите да следва номерацията. Табът в землището си остава след
                С1 (така е поискан и одобрен в Ф4). */}
            {/* Щ3: описанието е НАД избора на землище, както при всички останали. */}
            <ReportCard title="С13 — БП и пътища" hint={HINTS.s13}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker value={s13Settlement} onChange={setS13Settlement}
                                      listId="s13-settlements" options={settlementsWithData}/>
                    <button className="btn btn-outline-primary" onClick={goS13}
                            disabled={!s13Settlement}>Покажи
                    </button>
                </div>
            </ReportCard>

            {/* С14 — изчертано, текуща срещу предходна година (Ш4) */}
            <ReportCard title="С14 — Изчертани площи, текуща и предходна година"
                        hint={`${HINTS.s14} Попълнете само едно от двете — землище или община.`}>
                <div className="d-flex gap-2 align-items-end flex-wrap">
                    <SettlementPicker label="Землище:" value={s14Settlement} onChange={setS14Settlement}
                                      listId="s14-settlement" options={settlementsWithData}
                                      disabled={!!s14Municipality}/>
                    <MunicipalityPicker label="или Община:" value={s14Municipality} onChange={setS14Municipality}
                                        listId="s14-municipality" options={municipalitiesWithData}
                                        disabled={!!s14Settlement}/>
                    <CompanyPicker label="Ползвател:" value={s14Company} onChange={setS14Company}
                                   listId="s14-company" options={companiesOptions}/>
                    <button className="btn btn-outline-primary"
                            onClick={() => goScopeReport('s14', s14Settlement, s14Municipality, s14Company)}
                            disabled={(!s14Settlement && !s14Municipality) || !s14Company}>Покажи
                    </button>
                </div>
            </ReportCard>
        </div>
    );
};
